const response = await fetch(`${process.env.PUBLIC_URL}/config.json`);
const keys = await response.json();

var configuration;

const prod = {
  tenantId: keys.REACT_APP_TENANT_ID,
};
const dev = {
  tenantId: keys.REACT_APP_TENANT_ID,
};
const local = {
  tenantId: keys.REACT_APP_TENANT_ID
};

if (window.location.hostname.includes("localhost")) {
  configuration = local;
} else {
  configuration = prod;
}

export const config = configuration;
